export default __webpack_public_path__ + "static/media/submit.9d83b59e.jpeg";